import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import usePageTitle from 'hooks/usePageTitle';
import { Modal as BootstrapModal, Button } from 'react-bootstrap';
// blocks
import PageMenu from "../../blocks/PageMenu/PageMenu";
import Modal from "../../blocks/Modal/Modal";
import FormPassword from "../../blocks/Forms/FormPassword";
import { TextMessagesTemplates } from "../../blocks/TextMessagesTemplates/TextMessagesTemplates";
import { BankAccountList, BankAccountForm } from "../../blocks/BankAccount";
// hooks
import useDecode from "../../../hooks/useDecode";
import useModal from "../../../hooks/useModal";
import useBankAccounts from "../../../services/user/useBankAccounts";
// types
import { IBankAccount, IBankAccountCreate, IBankAccountUpdate } from "../../../INTERFACES/bankAccount";
// styles
import "./Settings.scss";
// services

import useGetAllProvinceUser from "../../../services/utils/useGetAllProvinceUser";
import useGetTypeRoad from "../../../services/utils/useGetTypeRoad";
import { user } from "@solimat/solimat-web-endpoint";
import useGetCompleteUser from "services/user/useGetCompleteUser";

const SettingsNew: React.FC = () => {
  const navigate = useNavigate();
  usePageTitle('Ajustes');
  const [userToken, setUserToken] = useState<any>({});
  const [userAddress, setUserAddress] = useState<any>({});
  const [completeUser, setCompleteUser] = useState<any>({});
  const [errorRequest, setErrorRequest] = useState<boolean>(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const { collapsed, childrenProps, handleOpenModal, handleCloseModal } =
    useModal();
  const { allTypeRoad, getAllTypeRoad } = useGetTypeRoad();
  const [typeRoadState, setTypeRoadState] = useState([])
  const [typeProviceCode, setTypeProviceCode] = useState([])
  const { allProvinceUser, getAllProvinceUser } = useGetAllProvinceUser();
  const tokenResponse = useDecode("token");

  // Bank accounts state and handlers
  const {
    accounts: bankAccounts,
    loading: loadingBankAccounts,
    error: bankAccountsError,
    getBankAccounts,
    createBankAccount,
    updateBankAccount,
    deleteBankAccount,
    setDefaultAccount,
    maskIban,
    canAddMore,
    MAX_ACCOUNTS,
  } = useBankAccounts();

  const { getCompleteUser } = useGetCompleteUser();

  const [showBankAccountModal, setShowBankAccountModal] = useState(false);
  const [editingAccount, setEditingAccount] = useState<IBankAccount | null>(null);
  const [savingBankAccount, setSavingBankAccount] = useState(false);
  const [accountToDelete, setAccountToDelete] = useState<string | null>(null);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [deletingAccount, setDeletingAccount] = useState(false);

  // Modal de resultado para cuentas bancarias
  const [showResultModal, setShowResultModal] = useState(false);
  const [resultModalTitle, setResultModalTitle] = useState('');
  const [resultModalBody, setResultModalBody] = useState('');
  const [resultModalSuccess, setResultModalSuccess] = useState(true);
/* 
  useEffect(() => {
    getBankAccounts();
  }, []) */;

 /*  const handleAddBankAccount = () => {
    setEditingAccount(null);
    setShowBankAccountModal(true);
  }; */

 /*  const handleEditBankAccount = (account: IBankAccount) => {
    setEditingAccount(account);
    setShowBankAccountModal(true);
  }; */

 /*  const handleSaveBankAccount = async (data: IBankAccountCreate) => {
    setSavingBankAccount(true);
    try {
      let result;
      if (editingAccount) {
        const updateData: IBankAccountUpdate = {
          id: editingAccount.id,
          ...data,
        };
        result = await updateBankAccount(updateData);
        if (result) {
          setResultModalTitle('Cuenta actualizada');
          setResultModalBody('La cuenta bancaria se ha actualizado correctamente.');
          setResultModalSuccess(true);
        } else {
          setResultModalTitle('Error al actualizar cuenta');
          setResultModalBody('No se ha podido actualizar la cuenta bancaria. Por favor, inténtelo de nuevo.');
          setResultModalSuccess(false);
        }
      } else {
        result = await createBankAccount(data);
        if (result) {
          setResultModalTitle('Cuenta creada');
          setResultModalBody('La cuenta bancaria se ha creado correctamente.');
          setResultModalSuccess(true);
        } else {
          setResultModalTitle('Error al crear cuenta');
          setResultModalBody('No se ha podido crear la cuenta bancaria. Por favor, inténtelo de nuevo.');
          setResultModalSuccess(false);
        }
      }
      setShowBankAccountModal(false);
      setEditingAccount(null);
      setShowResultModal(true);
    } finally {
      setSavingBankAccount(false);
    }
  }; */

/*   const handleDeleteBankAccount = (accountId: string) => {
    setAccountToDelete(accountId);
    setShowDeleteConfirmModal(true);
  }; */

 /*  const confirmDeleteBankAccount = async () => {
    if (!accountToDelete) return;

    setDeletingAccount(true);
    const result = await deleteBankAccount(accountToDelete);
    setDeletingAccount(false);
    setShowDeleteConfirmModal(false);
    setAccountToDelete(null);

    if (result) {
      setResultModalTitle('Cuenta eliminada');
      setResultModalBody('La cuenta bancaria se ha eliminado correctamente.');
      setResultModalSuccess(true);
    } else {
      setResultModalTitle('Error al eliminar');
      setResultModalBody('No se ha podido eliminar la cuenta bancaria. Por favor, inténtelo de nuevo.');
      setResultModalSuccess(false);
    }
    setShowResultModal(true);
  }; */

  /* const cancelDeleteBankAccount = () => {
    setShowDeleteConfirmModal(false);
    setAccountToDelete(null);
  }; */

/*   const handleSetDefaultBankAccount = async (accountId: string) => {
    await setDefaultAccount(accountId);
  }; */

 /*  const handleCloseBankAccountModal = () => {
    setShowBankAccountModal(false);
    setEditingAccount(null);
  }; */

  useEffect(() => {
    getAllTypeRoad().then((res)=>{
      setTypeRoadState(res);
    });
    getAllProvinceUser().then((res)=>{
      setTypeProviceCode(res);
    });
  }, []);

  useEffect(() => {
    if (typeRoadState?.length > 0 && typeProviceCode?.length > 0) {
      getCompleteUserLocal();
    }
  }, [typeRoadState, typeProviceCode]);
 

  const getProvinceUser = (cod: string, data: any) => {
    const province = data?.filter((prov: any) => prov.Codigo === cod);
    return province && province[0]?.Descripcion;
  };
  const getTypeRoad = (cod: string, data: any) => {
    const roadType = data?.filter((type: any) => type.Codigo === cod);
    return roadType && roadType[0]?.Descripcion1;
  };
 
  const getCompleteUserLocal = () => {
    if (tokenResponse !== undefined) {
      setUserToken(tokenResponse);
      getCompleteUser(tokenResponse.extension_id)
        .then((res: any) => { 
          let formated_phone = "";
          let formated_email_address = "";
          const userMainPhone = res["telefonos"].filter(
            (telefono: any) => telefono?.principal
          );
          const userMainEmail = res["emails"].filter(
            (email: any) => email.principal
          );
          if (userMainEmail.length) {
            formated_email_address = userMainEmail[0].correo;
          }
          if (userMainPhone.length) {
            formated_phone = userMainPhone[0].numero;
          }

          setCompleteUser({ ...res, formated_email_address, formated_phone });
          saveAddress(res.direcciones);
          setLoadingPage(false);
        })
        .catch((err: any) => {
          setErrorRequest(true);
          setLoadingPage(false);
        });
    } else {
      navigate("/");
    }
  };
  const saveAddress = (data: any[]) => {
    const mainAddress = data.filter((direccion: any) => direccion.principal);
    if (mainAddress.length >= 1) {
      const formatedAddress = formatAddress(mainAddress[0]);
      setUserAddress({
        userAddress: mainAddress[0],
        formatedAddress: formatedAddress,
      });
    } else if (data.length >= 1) {
      const formatedAddress = formatAddress(data[0]);

      setUserAddress({
        userAddress: data[0],
        formatedAddress: formatedAddress,
      });
    }
  };

  const formatAddress = (address: any) => {
    
    const {
      nombreVia,
      tipoViaCodigo,
      numero,
      bisNumero,
      bloque,
      piso,
      puerta,
      escalera,
      codigoPostal,
      codigoProvincia,
      localidad,
    } = address;
    const tipoViaDescripcion2 = getTypeRoad(tipoViaCodigo && tipoViaCodigo, typeRoadState && typeRoadState)||'';
    const provincia2 = getProvinceUser(codigoProvincia, typeProviceCode && typeProviceCode)|| '';
    let formatedAddress: string = "";
    let formatedStreet: string = "";
    if (tipoViaDescripcion2 && nombreVia) {
      if (nombreVia) {
        if (tipoViaDescripcion2)
          formatedStreet += `  ${tipoViaDescripcion2}  -` || '';
        formatedStreet += ` ${nombreVia}` || '';
      }
      if (formatedStreet) {
        formatedAddress += formatedStreet;
        numero
          ? (formatedAddress += `, número ${numero} `||'')
          : (formatedAddress += "");
        bisNumero
          ? (formatedAddress += `, Bis- ${bisNumero} ` ||'')
          : (formatedAddress += "");
        if (bloque) formatedAddress += `, bloque ${bloque} ` || '';
        if (escalera) formatedAddress += `, escalera ${escalera}`||'';
        if (piso) formatedAddress += `, piso ${piso}`;
        if (puerta) formatedAddress += `, puerta ${puerta}`||'';
      }

      if (formatedStreet && codigoPostal) {
        formatedAddress += `, C.P. ${codigoPostal}`;
      } else if (!formatedStreet && codigoPostal) {
        formatedAddress += `C.P. ${codigoPostal}` ||'';
      }

      if ((formatedStreet || codigoPostal) && localidad) {
        formatedAddress += ` - ${localidad}`;
      } else if (!formatedStreet && !codigoPostal && !provincia2 && localidad) {
        formatedAddress += `${localidad}` ||'';
      }

      if ((formatedStreet || codigoPostal || localidad) && provincia2) {
        formatedAddress += `  - ${provincia2}`;
      } else if ((!formatedStreet || !codigoPostal) && provincia2) {
        formatedAddress += `  - ${provincia2}` ||'';
      }

    }

    return formatedAddress;
  };
  const handleToEdit = (e: any) => {
    navigate(e.target.id, {
      state: {
        completeUser: completeUser,
      }
    });
  };
  return (
    <>
      <PageMenu
        title="Ajustes de usuario"
        breadcrumbs={["Ajustes de usuario"]}
      />
      {errorRequest && <section>{TextMessagesTemplates.errorResponse}</section>}

      {loadingPage ? (
        <section>{TextMessagesTemplates.loading}</section>
      ) : (
        <>
          {completeUser?.id && (
            <section className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="user-data-block">
                    <h3 className="label">Nombre</h3>
                    <p className="text">
                      {completeUser.nombre ? completeUser.nombre : "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="user-data-block">
                    <h3 className="label">Primer Apellido</h3>
                    <p className="text">
                      {completeUser.apellido1 ? completeUser.apellido1 : "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="user-data-block">
                    <h3 className="label">Segundo Apellido</h3>
                    <p className="text">
                      {completeUser.apellido2 ? completeUser.apellido2 : "-"}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="user-data-block">
                    <h3 className="label">Número de teléfono</h3>
                    <p className="text">
                      {completeUser.formated_phone
                        ? completeUser.formated_phone
                        : "-"}
                    </p>
                  </div>
                </div>
                <div className="col-12">
                  <div className="user-data-block">
                    <h3 className="label">Domicilio</h3>
                    <p className="text address">
                      {userAddress?.userAddress?.id !== undefined
                        ? userAddress?.formatedAddress
                        : `-`}
                    </p>
                  </div>
                </div>
                <div className="col-12">
                  <div className="user-data-block">
                    <h3 className="label">Email</h3>
                    <p className="text email">
                      {completeUser?.formated_email_address
                        ? completeUser?.formated_email_address
                        : "-"}
                    </p>
                  </div>
                </div>
                <div className="container-btn-edit-use">
                  <button
                    className="btn-text "
                    onClick={(e) => handleToEdit(e)}
                  >
                    <h3
                      className="btn-text icon-right text-btn-edit-user"
                      id="/ajustes/editar-usuario"
                    >
                      Editar datos de Usuario
                    </h3>
                  </button>
                </div>

                {/* Seccion Datos Bancarios */}
               {/*  <div className="col-12">
                  <div className="user-data-block bank-accounts-section">
                    <h3 className="label">Datos Bancarios</h3>
                    <BankAccountList
                      accounts={bankAccounts}
                      onEdit={handleEditBankAccount}
                      onAdd={handleAddBankAccount}
                      onSetDefault={handleSetDefaultBankAccount}
                      onDelete={handleDeleteBankAccount}
                      maskIban={maskIban}
                      canAddMore={canAddMore()}
                      maxAccounts={MAX_ACCOUNTS}
                    />
                  </div>
                </div> */}

                <div className="col-12">
                  <div className="change-password">
                    <h3 className="label">Contraseña</h3>

                    <a
                      className="btn-text icon-right"
                      href={`${import.meta.env.VITE_REACT_APP_AUTH_B2C_PATH}oauth2/v2.0/authorize?p=${import.meta.env.VITE_REACT_APP_B2C_PR_POLICY}&client_id=${import.meta.env.VITE_REACT_APP_CLIENT_ID}&nonce=defaultNonce&redirect_uri=${import.meta.env.VITE_REACT_APP_URL_BASE_WEB}%2Finicio&scope=openid&response_type=id_token&prompt=login&ui_locales=es`}
                    >
                      Cambiar contraseña
                    </a>
                  </div>
                </div>
              </div>
            </section>
          )}
        </>
      )}

      <Modal
        collapsed={collapsed}
        onClose={handleCloseModal}
        title="Introduzca su contraseña"
        subtitle="Para editar sus datos, necesitamos verificar su contraseña"
      >
        {collapsed ? (
          <div className="ghost-form"></div>
        ) : (
          <FormPassword
            redirectPath={childrenProps.path}
            onClose={handleCloseModal}
            completeUser={completeUser}
          />
        )}
      </Modal>

      {/* Modal para agregar/editar cuenta bancaria */}
   {/*    <Modal
        collapsed={!showBankAccountModal}
        onClose={handleCloseBankAccountModal}
        title={editingAccount ? "Editar cuenta bancaria" : "Agregar cuenta bancaria"}
        subtitle="Introduce los datos de tu cuenta bancaria"
      >
        {showBankAccountModal && (
          <BankAccountForm
            account={editingAccount}
            onSave={handleSaveBankAccount}
            onCancel={handleCloseBankAccountModal}
            loading={savingBankAccount}
          />
        )}
      </Modal> */}

      {/* Modal de confirmación para eliminar cuenta bancaria */}
      {/* <BootstrapModal show={showDeleteConfirmModal} onHide={cancelDeleteBankAccount} centered>
        <BootstrapModal.Header closeButton={false} className='header-modal-observaciones-rd'>
          <BootstrapModal.Title>
            <h2 className='title-insert-otp'>Eliminar cuenta</h2>
          </BootstrapModal.Title>
        </BootstrapModal.Header>
        <BootstrapModal.Body className='body-modal-observaciones-rd text-center'>
          <p className='text-body-modal-observaciones-rd'>¿Está seguro de que desea eliminar esta cuenta bancaria?</p>
        </BootstrapModal.Body>
        <BootstrapModal.Footer className='justify-content-center'>
          <Button variant="secondary" onClick={cancelDeleteBankAccount} disabled={deletingAccount}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={confirmDeleteBankAccount} disabled={deletingAccount}>
            {deletingAccount ? 'Eliminando...' : 'Eliminar'}
          </Button>
        </BootstrapModal.Footer>
      </BootstrapModal> */}

      {/* Modal de resultado para cuentas bancarias */}
     {/*  <BootstrapModal show={showResultModal} onHide={() => setShowResultModal(false)} centered>
        <BootstrapModal.Header closeButton={false} className='header-modal-observaciones-rd'>
          <BootstrapModal.Title>
            <h2 className='title-insert-otp'>{resultModalTitle}</h2>
          </BootstrapModal.Title>
        </BootstrapModal.Header>
        <BootstrapModal.Body className='body-modal-observaciones-rd text-center'>
          <p className='text-body-modal-observaciones-rd'>{resultModalBody}</p>
        </BootstrapModal.Body>
        <BootstrapModal.Footer className='justify-content-center'>
          <Button variant="secondary" onClick={() => setShowResultModal(false)}>
            Aceptar
          </Button>
        </BootstrapModal.Footer>
      </BootstrapModal> */}
    </>
  );
};

export default SettingsNew;
